module.exports = __webpack_public_path__ + "assets/3228c8fce2909ab51114f7b3033758a6.png";